import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBar = () => {
  const partners = [
    { name: 'GRP Battery', icon: 'Battery', label: 'Leverancier' },
    { name: 'ZekerZon', icon: 'Monitor', label: 'Installateur & Monitoring' },
  ];

  return (
    <section className="bg-gray-50 border-y border-border py-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Partners */}
          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-6">
            <span className="text-xs font-caption text-muted-foreground uppercase tracking-wider">Partners:</span>
            {partners?.map((p) => (
              <div key={p?.name} className="flex items-center space-x-2">
                <div className="w-7 h-7 bg-primary/10 rounded-md flex items-center justify-center">
                  <Icon name={p?.icon} size={14} className="text-primary" />
                </div>
                <div>
                  <p className="text-xs font-heading font-semibold text-foreground leading-none">{p?.name}</p>
                  <p className="text-[10px] font-caption text-muted-foreground">{p?.label}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Kiwa badge */}
          <a
            href="#"
            className="flex items-center space-x-3 bg-white border border-blue-200 rounded-lg px-4 py-2.5 hover:border-blue-400 transition-colors group"
            title="Bekijk Kiwa testrapport 24PP484-01"
          >
            <div className="w-8 h-8 bg-blue-50 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Award" size={16} className="text-blue-600" />
            </div>
            <div>
              <p className="text-xs font-heading font-bold text-foreground">Kiwa Primara gecertificeerd</p>
              <p className="text-[10px] font-caption text-blue-600 group-hover:underline">
                Batterijcellen getest · UN 38.3 · Rapport 24PP484-01
              </p>
            </div>
            <Icon name="ExternalLink" size={12} className="text-muted-foreground" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
